.board {
	display: flex;
	flex-direction: column;
	min-block-size: 0;
}

/* Keep the inline quick-add in the empty state to a sensible input width rather
   than stretching across the whole board area. */
.emptyAdd {
	inline-size: 100%;
	max-inline-size: 22rem;
	text-align: start;
}
